// extracted by mini-css-extract-plugin
module.exports = {"error-content":"ErrorTemplate_error-content__Rko18"};